import { continueScroll, prevScroll } from './Scroll';

export default class Scroller {
  lastKey = -1;

  constructor() {
    this.setup();
  }

  // --------------------------------------------------------------
  // Setup
  // --------------------------------------------------------------

  setup(): void {
    this.setKeyboard();
  }

  // --------------------------------------------------------------
  // Keyboard
  // --------------------------------------------------------------

  setKeyboard(): void {
    window.addEventListener('keydown', (event) => {
      switch (event.key) {
        case 'PageDown':
        case ' ':
          event.preventDefault();
          continueScroll();
          break;
        case 'PageUp':
          event.preventDefault();
          prevScroll();
          break;
        default:
          break;
      }
    });
    window.addEventListener('keyup', () => {
      this.lastKey = -1;
    });
  }
}
